import React from "react";
import { MailTo } from "../components/MailTo";

export const PageFooter = () => {
  return (
    <footer
      className="d-flex align-items-center justify-content-center border border-top-1 bg-light"
      style={{ height: "4em", fontSize: "0.875em" }}
    >
      We&apos;d love to hear your feedback!&nbsp;&nbsp;
      <MailTo
        email="herdplan@sruc.ac.uk"
        subject="HerdPlan forecast"
        text="Contact Us"
      />
    </footer>
  );
};
